export default {
    data() {
        return {};
    },
    methods: {
        formatUrlSearchString(sessionKey) {
            let search = '?';
            search = search + 'prevPage=' + (this.$refs.table.tableData.meta ? this.$refs.table.tableData.meta.current_page : 1);
            for (let key in this.filters) {
                search += `&${key}=${this.filters[key]}`;
            }

            return search;
        },
        applyUrlSearch(sessionKey, applyKey) {
            let applySearch = sessionStorage.getItem(applyKey);
            if (applySearch === '1') {
                let urlSearch = sessionStorage.getItem(sessionKey);
                sessionStorage.setItem(applyKey, '0');
                let interval = setInterval(() => {
                    if (this.$refs.pagination) {
                        clearInterval(interval);
                        let url = new URL(urlSearch, window.location.href);

                        let page = url.searchParams.get('prevPage');
                        url.searchParams.delete('prevPage');

                        url.searchParams.forEach((value, name) => {
                            if (this.filters[name] != value) {
                                console.log(name);
                                this.$set(this.filters, name, value);
                            }
                        });

                        if (this.status !== undefined) {
                            this.status = parseInt(url.searchParams.get('activeStatus'));
                        }

                        if (page > 1) {
                            this.$refs.pagination.changePage('', page);
                        }
                    }
                }, 20);
            }
        }
    },
};
